import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import LogoComponent from "../../components/LogoComponent";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { useValidation } from "../../context/ValidationContext";

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { validateEmail } = useValidation();
  const { t } = useContext(TranslatorContext);

  const validatePassword = (password) => {
    return password.length >= 8;
  };

  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const [submitted, setSubmitted] = useState(false);

  // 1. Loading state add kiya gaya hai
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (submitted) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    let newErrors = { email: "", password: "" };
    let hasError = false;

    if (!values.email.trim()) {
      newErrors.email = "Email is required";
      hasError = true;
    } else if (!validateEmail(values.email)) {
      newErrors.email = "Invalid email address";
      hasError = true;
    }

    if (!values.password.trim()) {
      newErrors.password = "Password is required";
      hasError = true;
    } else if (!validatePassword(values.password)) {
      newErrors.password = "Password must be at least 8 characters";
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    setIsLoading(true);

    try {
      const res = await axios.post(
        process.env.REACT_APP_API_URL + "/login",
        {
          email: values.email.trim(),
          password: values.password.trim(),
        }
      );

      if (res && res.data.success) {
        localStorage.setItem("authToken", res.data.data?.token);
        localStorage.setItem("user", JSON.stringify(res.data.data?.user));
        localStorage.setItem("permissions", JSON.stringify(res.data.data?.permissions));
        localStorage.setItem("role", res.data.data?.roles || "");
        login(res.data);

        window.location.href = "/dashboard";
        // Note: Success hone par redirect ho jayega, isliye isLoading false karne ki zarurat nahi
      } else {
        setErrors({
          ...newErrors,
          password: "Invalid email or password",
        });
        // Error aane par wapas false kar diya
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error during login:", error);
      setErrors({
        ...newErrors,
        password: "Invalid email or password",
      });
      // Catch block mein bhi false kar diya
      setIsLoading(false);
    }
  };

  return (
    <div className="mc-auth">
      <img src="/images/pattern.webp" alt="pattern" className="mc-auth-pattern" />

      <div className="mc-auth-group">
        <LogoComponent
          src="/images/logo.png"
          alt="logo"
          href="/"
          className="mc-auth-logo"
        />

        <h4 className="mc-auth-title">Login to Pet Management</h4>

        <form onSubmit={handleLogin} className="mc-auth-form">

          <IconFieldComponent
            icon="email"
            type="email"
            name="email"
            onChange={handleChange}
            classes="w-100 h-sm"
            placeholder="Enter your email"
            value={values.email}
          />

          {errors.email && (
            <span style={{ color: "red", fontSize: "14px" }}>
              {errors.email}
            </span>
          )}

          <IconFieldComponent
            icon="lock"
            type="password"
            name="password"
            onChange={handleChange}
            classes="w-100 h-sm"
            placeholder="Enter your password"
            passwordVisible={true}
            value={values.password}
          />

          {errors.password && (
            <span style={{ color: "red", fontSize: "14px" }}>
              {errors.password}
            </span>
          )}

          {/* 3. Button ko isLoading state ke basis par disable kiya gaya hai */}
          <ButtonComponent
            className="mc-auth-btn h-sm"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : t("sign_in")}
          </ButtonComponent>

          <AnchorComponent className="mc-auth-forgot" to="/forgot-password">
            {t("forgot_password")}
          </AnchorComponent>

        </form>
      </div>
    </div>
  );
}